import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { DoBootstrap, ErrorHandler, NgModule } from '@angular/core';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/slide-toggle';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from '@auth0/auth0-angular';
import { environment } from 'environments/environment';
import { fusionStoreProvider } from '../core/h3ml/state/task-workspace-store';
import { LoginWorkspaceModule } from '../core/login-workspace/login-workspace.module';
import { PreviewWorkspaceModule } from '../core/preview-workspace/preview-workspace.module';
import { ProductionWorkspaceModule } from '../core/production-workspace/production-workspace.module';
import { ReadOnlyWorkspaceModule } from '../core/read-only-workspace/read-only-workspace.module';
import { SamplingWorkspaceModule } from '../core/sampling-workspace/sampling-workspace.module';
import { ErrorHandlerService } from '../cross-team-shared/messaging/error-handler.service';
import { HttpErrorInterceptor } from '../cross-team-shared/messaging/http-error-interceptor';
import { UnauthorizedInterceptor } from '../cross-team-shared/messaging/unauthorized-interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AuthModule.forRoot({
      domain: environment.auth0Domain,
      clientId: environment.auth0ClientId,
      authorizationParams: {
        audience: 'https://sama-api.samasource.org',
        redirect_uri: `${window.location.origin}/workspace_callback`,
      },
    }),
    AppRoutingModule,
    LoginWorkspaceModule,
    PreviewWorkspaceModule,
    ProductionWorkspaceModule,
    ReadOnlyWorkspaceModule,
    SamplingWorkspaceModule,
  ],
  declarations: [AppComponent],
  providers: [
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: 'primary' },
    },
    {
      provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,
      useValue: { color: 'primary' },
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: { disableTooltipInteractivity: true, position: 'above' },
    },
    {
      provide: MAT_TABS_CONFIG,
      useValue: { animationDuration: '0' },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        panelClass: 'mat-elevation-z8',
        minWidth: '280px',
        maxWidth: '600px',
        restoreFocus: true,
      },
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
      useValue: {
        hideSingleSelectionIndicator: true,
        hideMultipleSelectionIndicator: true,
      },
    },
    fusionStoreProvider,
    provideHttpClient(withInterceptorsFromDi()),
  ],
  ...(window.STANDALONE ? { bootstrap: [AppComponent] } : {}),
})
export class AppModule implements DoBootstrap {
  // eslint-disable-next-line max-params-unless-injectable -- AppModule orchestrates multiple workspace modules via DI; exceeding 4 params is intentional here
  constructor(
    private productionWorkspaceModule: ProductionWorkspaceModule,
    private readOnlyWorkspaceModule: ReadOnlyWorkspaceModule,
    private samplingWorkspaceModule: SamplingWorkspaceModule,
    private previewWorkspaceModule: PreviewWorkspaceModule,
    private loginWorkspaceModule: LoginWorkspaceModule,
  ) {}

  ngDoBootstrap() {
    this.productionWorkspaceModule.ngDoBootstrap();
    this.readOnlyWorkspaceModule.ngDoBootstrap();
    this.samplingWorkspaceModule.ngDoBootstrap();
    this.previewWorkspaceModule.ngDoBootstrap();
    this.loginWorkspaceModule.ngDoBootstrap();
  }
}
